import { isAdmin } from 'src/config'

let Highcharts, HighchartsVue, highchartsMore
let isHighchartsLoaded = false

/**
 * This is a "get or initialize" function to fetch Highcharts. The Highcharts packages are
 * currently only used for Report components. To minimize the JS bundle size served to consumers,
 * we defer loading these packages until necessary using dynamic imports.
 * About Webpack magic comments: https://webpack.js.org/api/module-methods/#magic-comments
 */
const loadHighchartsAsync = async (app) => {
  if (!isHighchartsLoaded) {
    const promises = [
      import(/* webpackChunkName: "highcharts" */ 'highcharts').then((module) => {
        Highcharts = module.default
      }),
      import(/* webpackChunkName: "highcharts-vue" */ 'highcharts-vue').then((module) => {
        HighchartsVue = module.default
      }),
      import(/* webpackChunkName: "highcharts-more" */ 'highcharts/highcharts-more').then((module) => {
        highchartsMore = module.default
      })
    ]

    await Promise.all(promises)
    if (Highcharts && HighchartsVue && highchartsMore) {
      highchartsMore(Highcharts)
      app.use(HighchartsVue, { Highcharts })
      isHighchartsLoaded = true
    }
  }
  return Highcharts
}

export default async ({ app }) => {
  // We add a getter method to Vue so that components can opt into Highcharts
  // when necessary.
  app.config.globalProperties.$getHighchartsAsync = async function () {
    return await loadHighchartsAsync(app)
  }

  if (isAdmin) {
    // Admin app mode users are more likely than not to see report or chart components, including
    // on the dashboard BookingWeek scheduler. So we lazy load Highcharts in Admin immediately.
    loadHighchartsAsync(app)
  }
}
